<script lang="ts" setup>
import Button from '@/Components/Ui/Button.vue';
import Input from '@/Components/Ui/Input.vue';
import { login } from '@/routes';
import { Link, useForm } from '@inertiajs/vue3';

const props = defineProps<{
    isInvitation?: boolean;
    email?: string;
}>();

const emit = defineEmits<{
    (e: 'submit', form: ReturnType<typeof useForm>): void;
}>();

const form = useForm({
    name: '',
    email: props.email ?? '',
    password: '',
    password_confirmation: '',
});
</script>

<template>
    <form @submit.prevent="emit('submit', form)" class="space-y-4">
        <Input
            v-model="form.name"
            :label="$t('auth.fields.name')"
            type="text"
            :error="form.errors.name"
            required
            autofocus
            autocomplete="name"
        />

        <Input
            v-model="form.email"
            :label="$t('auth.fields.email')"
            type="email"
            :error="form.errors.email"
            required
            autocomplete="username"
        />

        <Input
            v-model="form.password"
            :label="$t('auth.fields.password')"
            type="password"
            :error="form.errors.password"
            required
            autocomplete="new-password"
        />

        <Input
            v-model="form.password_confirmation"
            :label="$t('auth.fields.confirm_password')"
            type="password"
            :error="form.errors.password_confirmation"
            required
            autocomplete="new-password"
        />

        <div class="flex items-center justify-end pt-2">
            <Link
                v-if="!props.isInvitation"
                :href="login().url"
                class="text-text-soft hover:text-ink text-sm underline"
            >
                {{ $t('auth.register.already_registered') }}
            </Link>

            <Button
                type="submit"
                class="ms-4"
                :disabled="form.processing"
                :loading="form.processing"
            >
                {{
                    props.isInvitation
                        ? $t('households.invitation.create.button_register')
                        : $t('auth.register.button')
                }}
            </Button>
        </div>
    </form>
</template>
